<template>
  <div class="file-card">

    <file-text-icon size="2x" class="file-icon"/>

    <div class="file-info">
      <span class="file-name">{{ file.name }}</span>
      <span class="file-meta">{{ size }} · enviado em {{ uploadedAt }}</span>
    </div>

    <button @click="$emit('open')" class="btn btn-outline btn-sm mr-1">Visualizar</button>

    <Upload class="replace" :is-multiple="false" :accept="accept"
            list-class="replace-area" :method="replace">
      <span class="replace-label">Substituir</span>
    </Upload>

    <button @click="$emit('remove')" class="icon-button" title="Remover arquivo">
      <trash-2-icon size="1x"/>
    </button>

  </div>
</template>

<script>
  import { FileTextIcon, Trash2Icon } from 'vue-feather-icons'
  import Upload from '@/components/shares/specialTag/Upload'

  export default {
    components: { FileTextIcon, Trash2Icon, Upload },
    computed: {
      size() {
        const bytes = this.file.size

        if (!bytes && bytes !== 0)
          return 'tamanho desconhecido'

        if (bytes < 1024)
          return `${bytes} B`

        if (bytes < 1024 * 1024)
          return `${(bytes / 1024).toFixed(0)} KB`

        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
      },
      uploadedAt() {
        return this.file.uploaded_at ? this.$options.filters.datetime(this.file.uploaded_at) : '-'
      }
    },
    methods: {
      replace(files) {
        this.$emit('replace', files)
      }
    },
    name: 'FileCard',
    props: {
      accept: { default: 'application/pdf,.pdf', type: String },
      file: { required: true, type: Object }
    }
  }
</script>

<style scoped>
  .file-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    margin: 16px 0;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    background: var(--card-bg);
  }

  .file-icon {
    color: var(--icon-color);
  }

  .file-info {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .file-name {
    font-size: 14px;
    font-weight: 600;
    color: var(--primary-text-color);
  }

  .file-meta {
    font-size: 12px;
    color: var(--secondary-text-color);
  }

  .replace {
    margin: 0;
  }

  .replace-area {
    width: auto;
    height: auto;
    margin: 0;
    padding: 6px 14px;
    border-style: solid;
    opacity: 1;
  }

  .replace-label {
    font-size: 13px;
    color: var(--btn-text-color);
  }

  .icon-button {
    padding: 4px;
    border: none;
    background: none;
    color: var(--icon-color);
    cursor: pointer;
  }

  .icon-button:hover {
    color: #d9534f;
  }
</style>
